module.exports = __webpack_public_path__ + "static/media/instructivoa1.36bcb3e9.png";